/* istanbul ignore file */
import { minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import {
  inset,
  mediaQuery,
  responsiveFontSize,
  shadowDown,
  shadowUp,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { MODAL_HEIGHT_CSS_VAR } from '../constants/cssVariables';

const { spacing, text, fonts } = theme;

export const modalSectionHeader = css`
  padding: ${inset(spacing.md, 26)};
  ${shadowDown}

  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;

  h2,
  h3 {
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    ${responsiveFontSize(text.lg)}
    line-height: 28px;

    margin: 0;
    text-transform: capitalize;
  }
`;

export const modalSectionControls = css`
  padding: ${inset(spacing.md, spacing.lg)};
  ${shadowUp}
`;

export const modalViewport = css`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: var(${MODAL_HEIGHT_CSS_VAR});
  min-height: 100%;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      height: auto;
    `,
  )};
`;

export const modalScrollableContent = css`
  flex-shrink: 1;
  flex-grow: 1;
  overflow-y: scroll;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      overflow: visible;
    `,
  )};
`;
